/**
 * /css/panel.css
 */

import React from "react";

export default function Dashed(props) {
    const CNDashed = ["panel-dashed"];
    props.className && CNDashed.push(props.className);
    props.solid && CNDashed.push("solid");
    return <div className={CNDashed.join(" ")}>{props.children}</div>;
}
